import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles({
  root: {
    padding: 25,
  },
  section: {
    border: '1px solid black',
    padding: '20px',
    margin: '10px 0',
  },
  dealerSelect: { marginTop: 30, marginLeft: 35, width: 200 },
  gridContainer: {
    paddingLeft: '30px !important',
    paddingRight: '30px !important',
    // marginTop: '30px !important',
  },
  paper: {
    border: '1px solid',
    borderColor: 'rgba(0, 0, 0, 0.1)',
    borderRadius: '5px !important',
    height: 'auto',
    padding: '50px',
  },
  dealerTypography: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    minHeight: '50vh',
  },
  generateTemplateButton: {
    display: 'flex',
    marginLeft: 'auto',
    marginRight: 'auto',
    width: '100%',
    color: 'white !important',
    marginTop: '90px !important',
  },
  refreshButton: {
    marginRight: 'auto !important',
    paddingLeft: '30px !important',
  },
  downloadButton: {
    marginLeft: 'auto !important',
    paddingRight: '30px !important',
  },
  accordion: {
    // marginLeft: '10px !important',
    // marginRight: '10px !important',
    marginTop: '20px !important',
    border: '1px solid',
    borderColor: 'rgba(0, 0, 0, 0.8)',
    borderRadius: '5px !important',
  },
  "toolbar": {
    "& .ql-toolbar $element": {
      backgroundColor: "red"
    },
    "& .ql-snow $element": {
      backgroundColor: "red"
    }
  }
});
